import Main from "./special/limited-screening/main.es6";

document.addEventListener("DOMContentLoaded", () => {
    new Main();
});
